import { render, staticRenderFns } from "./DetailsProductComponent.vue?vue&type=template&id=e392eb0a&scoped=true&"
import script from "./DetailsProductComponent.vue?vue&type=script&lang=js&"
export * from "./DetailsProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailsProductComponent.vue?vue&type=style&index=0&id=e392eb0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e392eb0a",
  null
  
)

export default component.exports